const cards = [
  {
    title: "COSMOPOLITAN PILGRIM",
    image: require("./cosmopolitanpilgrim.png"),
  },
  {
    title: "DESI DHABA",
    image: require("./desidhaba.png"),
  },
  {
    title: "JAANO INDIA",
    image: require("./jaano.png"),
  },
  {
    title: "STICKY REVIEWS",
    image: require("./stickyreviews.png"),
  },
  {
    title: "EXPLORING THE VALUE OF BOREDOM",
    image: require("./ux of boredom 1.png"),
  },
  {
    title: "ANTI-BOREDOM CAPSULE (ABC)",
    image: require("./ux of boredom 2.png"),
  },
  {
    title: "SENSING THE INVISIBLE",
    image: require("./ux of human senses.png"),
  },
  {
    title: "EXPERIENCE OF PAPER",
    image: require("./ux of paper 1.png"),
  },
  {
    title: "EDIBLE JOURNAL 2021",
    image: require("./ux of paper 2.png"),
  },
  {
    title: "SKIN WORLD INTERFACE",
    image: require("./ux of skin 1.png"),
  },
  {
    title: "CELEBRATING ‘FESTIVE’",
    image: require("./ux of skin 2.png"),
  },
  {
    title: "EXPLORING THE COLOUR YELLOW",
    image: require("./ux of yellow 1.png"),
  },
  {
    title: "EMOJIS AND JAUNDICE",
    image: require("./ux of yellow 2.png"),
  },
  {
    title: "APNA AI",
    image: require("./apna AI.png"),
  },
  {
    title: "Nivaaran — A Legal Awareness App for Women in India (2020)",
    image: require("./Nivaaran.png"),
  },
];

export default cards;
